import { literals } from './../../languages';


export default function(a, props) {
  const errors = {};
  const { values, locale } = props;
  const requiredFields = [
    'fullname',
    'email',
    'password',
    'verifyPassword',
  ];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = literals.required[locale];
    }
  });
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = literals.invalidEmail[locale];
  }

  if (values.password !== values.verifyPassword) {
    errors.verifyPassword = literals.passwordsMissmatch[locale];
  }
  return errors;
}



// WEBPACK FOOTER //
// ./src/components/register/validate.js